/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Signin2Inputs */

const en_locallogin_signin2 = /** @type {(inputs: Locallogin_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in (local session)`)
};

/**
* | output |
* | --- |
* | "Sign in (local session)" |
*
* @param {Locallogin_Signin2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_signin2 = /** @type {((inputs?: Locallogin_Signin2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Signin2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_signin2(inputs)
});
export { locallogin_signin2 as "localLogin_signIn" }